export const iconFontAwesomeHumanitarianTruckDroplet = (
	<i className="fa-solid fa-truck-droplet"></i>
);
